<template>
  <v-btn
    class="mt-3 text-subtitle-1 font-weight-bold"
    block
    color="#315ED9"
    dark
    type="submit"
    @submit.prevent="resetPassword"
    >{{ label }}</v-btn
  >
</template>

<script>
export default {
  name: 'ResetPasswordButton',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    resetPassword () {
      this.$emit('resetPassword')
    }
  }
}
</script>
